!((document, Drupal, $) => {
  'use strict';

  /**
   * Handles removing the expanded class on the main menu
   * when the window is resized.
   *
   * @return {undefined}
   */
  function removeExpandedOnResize() {
    var width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
    if (width >= 1100 && $('.main-menu').hasClass('expanded')) {
      $('.main-menu').removeClass('expanded');
      $('.main-menu-toggle').attr('aria-expanded', 'false');
      $('.main-menu-toggle').removeClass('is-open');
    }
  }

  /**
   * Collapses all dropdowns except any clickedElement
   * argument selector.
   *
   * @param {*} clickedElement A DOM element
   * @return {undefined}
   */
  function collapseDropdowns(clickedElement) {
    if (clickedElement) {
      $('.main-menu-item').each(function () {
        if ($(this)[0] !== $(clickedElement).closest('.main-menu-item')[0]) {
          $(this).removeClass('expanded');
        }
      });
    }
    else {
      $('.main-menu-item').removeClass('expanded');
    }
  }

  /**
   * Collapses the entire menu.
   *
   * @return {undefined}
   */
  function collapseMenu() {
    $('.main-menu-toggle').attr('aria-expanded', 'false');
    $('.main-menu-toggle').removeClass('is-open');
    $('.main-menu').removeClass('expanded');
    $('.main-menu-item').removeClass('expanded');
    $(document).off('click.collapse-main-menu');

    // Rebind the blur handler for the search.
    $('.main-menu-item.search .form-submit').unbind('blur');
    $('.main-menu-item.search .form-submit').blur(
      function () {
        collapseDropdowns();
      }
    );
  }

  /**
   * Adds a document handler to detect clicks outside
   * the clickedElement.
   *
   * Also attaches a hover handler to collapse
   * clickedElement when they are activated.
   *
   * @param {boolean} hover resets hover
   * @return {undefined}
   */
  function bodyClick(hover) {

    // Add the binding to collapse opened click items when
    // body is clicked outside those items.
    $(document).off('click.collapse-main-sub-menu');
    $(document).on('click.collapse-main-sub-menu', function (event) {
      if (!$(event.target).closest(
        '.main-menu-item'
      ).length) {
        collapseDropdowns();
        $(this).off('click.collapse-main-sub-menu');

        // Various functions remove this binding, put it back
        // just in case.
        $('.main-menu-item.search .form-submit').unbind('blur');
        $('.main-menu-item.search .form-submit').blur(
          function () {
            collapseDropdowns();
          }
        );
      }
    });

    if (hover) {
      // Hide any click elements when hover is active.
      $('.main-menu-item.hover').off('mouseenter mouseleave');
      $('.main-menu-item.hover').hover(
        function () {
          // Unbind the document handler.
          $(document).off('click.collapse-main-sub-menu');
          // Unbind the hover handler.
          $('.main-menu-item.hover').off('mouseenter mouseleave');
          collapseDropdowns();
        }
      );
    }
  }

  /**
   * Creates behaviors for main menu.
   */
  Drupal.behaviors.mainMenu = {
    attach: function (context) {

      // When the menu is expanded, the top-level hover links
      // need click actions to expand their child menus.
      $('.main-menu .main-menu-item.hover .main-menu-link, .main-menu .main-menu-item.hover .main-menu-sub-menu-toggle',
        context).once().click(
        function (event) {
          if ($('.main-menu').hasClass('expanded')) {
            var parent = $(this).parent();
            if ($(parent).hasClass('expanded')) {
              $(parent).removeClass('expanded');
            }
            else {
              $(parent).addClass('expanded');
            }
            // Prevent the normal click handler.
            event.preventDefault();
          }
        }
      );

      // Check for expanded class on the main menu when the
      // window is resized.
      $(window).resize(function () {
        removeExpandedOnResize();
        collapseDropdowns();
      });

      // Hamburger.
      $('.main-menu-toggle', context).once().click(function () {
        if ($(this).attr('aria-expanded') === 'true') {
          // Handle close.
          collapseMenu();
        }
        else {
          // Handle open.
          $(this).attr('aria-expanded', 'true');
          $(this).addClass('is-open');
          $('.main-menu').addClass('expanded');
          $('.main-menu-item.search').addClass('expanded');

          // Clear any existing bindings.
          $(document).off('click.collapse-main-sub-menu');
          $(document).off('click.collapse-main-menu');
          $('.main-menu-item.hover').off('mouseenter mouseleave');
          $('.main-menu-item.search .form-submit').unbind('blur');

          // Add document binding to collapse main menu when clicking
          // outside the navigation block.
          $(document).on('click.collapse-main-menu', function (event) {
            if (!$(event.target).closest(
              '.main-navigation'
            ).length) {
              collapseMenu();
            }
          });
        }
      });

      // Top-level link focus handler.
      $('.main-menu-link').on('focus', function (event) {
        if (!$('.main-menu').hasClass('expanded')) {
          collapseDropdowns();
          $(event.target).parent().addClass('expanded');

          // After a moment, attach hover and body handlers.
          // This allows a body click to close menus expanded by
          // tabbing through.
          setTimeout(() => {
            bodyClick();
          }, 1000);
        }
      });

      // Sub-level link focus handler.
      $('.main-menu-sub-link').on('focus', function (event) {
        collapseDropdowns(event.target);
        $(event.target).closest('.main-menu-link').addClass('expanded');
      });

      // Special handling for search as it's the last
      // element and stays open when tabbing through.
      $('.main-menu-item.search .form-submit').blur(
        function () {
          collapseDropdowns();
        }
      );

      // Unbind the blur handler when the search input is clicked.
      $('.main-menu-item.search .form-text').on('click', function () {
        if (!$('.main-menu').hasClass('expanded')) {
          $('.main-menu-item.search .form-submit').unbind('blur');

          // After a moment, attach hover and body handlers.
          setTimeout(() => {
            bodyClick(true);
          }, 1000);
        }
      });

      // Menu element click handler.
      $('.main-menu-item.click .main-menu-link',
        context).once().click(function (event) {
        if (!$('.main-menu').hasClass('expanded')) {
          // Collapse any other dropdowns.
          collapseDropdowns(event.target);

          // Add the expanded class.
          $(event.target).closest('.main-menu-item').addClass('expanded');

          // Unbind the blur handler.
          $('.main-menu-item.search .form-submit').unbind('blur');

          // Prevent the normal click handler.
          event.preventDefault();

          // After a moment, attach hover and body handlers.
          setTimeout(() => {
            bodyClick(true);
          }, 1000);
        }
      });

    }
  };
})(document, Drupal, jQuery);
